import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [entitlements, setEntitlements] = useState({ has_part_1: false, has_part_2: false, has_part_3: false, bundle_owner: false });

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("nmos_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setEntitlements(data.entitlements);
    } catch {
      localStorage.removeItem("nmos_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const applyAuth = (data) => {
    localStorage.setItem("nmos_token", data.token);
    setUser(data.user);
    loadMe();
  };

  const logout = () => {
    localStorage.removeItem("nmos_token");
    setUser(false);
    setEntitlements({ has_part_1: false, has_part_2: false, has_part_3: false, bundle_owner: false });
  };

  return (
    <AuthContext.Provider value={{ user, entitlements, applyAuth, logout, refresh: loadMe, setEntitlements }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
